import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CardFilter2Pipe } from "./card-filter-2.pipe";
import { CardFilterPipe } from "./card-filter.pipe";
import { CardSortPipe } from "./card-sort.pipe";
import { DailyPeriodPipe } from "./daily-period.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { SearchTextPipe } from "./search-text.pipe";
@NgModule({
  declarations: [
    SearchTextPipe,
    DailyPeriodPipe,
    CardFilterPipe,
    SafeHtmlPipe,
    CardSortPipe,
    CardFilter2Pipe,
  ],
  imports: [CommonModule],
  exports: [
    SearchTextPipe,
    DailyPeriodPipe,
    CardFilterPipe,
    SafeHtmlPipe,
    CardSortPipe,
    CardFilter2Pipe,
  ],
})
export class PipesModule {}
